/* eslint-disable sui/factory-pattern */
import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import Config from '../index.js'

export class ConfigContext {
  static config = null

  static validateConfigInstance(configInstance) {
    if (!(configInstance instanceof Config)) {
      throw DomainSharedError.createFromPrimitives({
        cause: new Error('Invalid config instance'),
        code: 'INVALID_CONFIG_INSTANCE',
        message: 'Invalid config instance'
      })
    }
  }

  static validateConfigInit() {
    if (!ConfigContext.config) {
      throw DomainSharedError.createFromPrimitives({
        cause: new Error('Config not initialized'),
        code: 'CONFIG_NOT_INITIALIZED',
        message: 'Config not initialized'
      })
    }
  }

  static initialize(configInstance) {
    ConfigContext.validateConfigInstance(configInstance)
    ConfigContext.config = configInstance
  }

  static get(path) {
    ConfigContext.validateConfigInit()
    return ConfigContext.config.get(path)
  }
}
